module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av499-570d940ebaef8b213d5ce4268cf9ca93.jpg";